import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, startWith, switchMap} from 'rxjs/operators';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {AsyncPipe, CommonModule} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {CatalogResource, CatalogsService, FieldResource} from '../../core/modules/openapi';
import {MatOptionSelectionChange} from '@angular/material/core';

@Component({
  selector: 'app-catalog-data-search',
  imports: [FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    AsyncPipe, CommonModule],
  templateUrl: './catalog-data-search.component.html',
  standalone: true,
  styleUrl: './catalog-data-search.component.sass'
})
export class CatalogDataSearchComponent implements OnInit {
  @Input() maxCatalogs = 10;
  @Input() type: string;
  @Input() selector: string;
  field: FieldResource;
  group: FormGroup;
  catalogCtrl: FormControl;
  filteredCatalogs: Observable<CatalogResource[]>;
  selectedCatalog: CatalogResource;

  constructor(private readonly catalogsService: CatalogsService) {
  }

  ngOnInit(): void {
    this.catalogCtrl = new FormControl({value: '', disabled: !this.field.enabled});
    let inputType = this.field.inputType?.split('/');
    this.type = inputType?.[0] || '';
    this.selector = inputType?.[1] || '';
    this.filteredCatalogs = this.catalogCtrl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(catalog => (catalog ? this._filterCatalogs(catalog) : [])),
    );
    if (this.field.value) {
      this._filterCatalogs(this.field.value as string)
      .subscribe(result => this.catalogCtrl.setValue(this.getDisplay(result[0])));
    }
  }

  private _filterCatalogs(value: string): Observable<CatalogResource[]> {
    return this.catalogsService.searchCatalogData(this.type, this.selector, value);
  }

  public checkCatalog() {
    if (this.selectedCatalog) {
      const selectedDisplay = this.getDisplay(this.selectedCatalog);
      if (this.catalogCtrl.value !== selectedDisplay) {
        this.catalogCtrl.setValue('');
      } else {
        this.field.value = this.selectedCatalog.code || '';
      }
    }
  }

  catalogSelected($event: MatOptionSelectionChange, catalog: CatalogResource) {
    if ($event.isUserInput) {
      this.selectedCatalog = catalog;
      this.field.value = catalog.code || '';
      this.group.controls[this.field.name]?.setValue(this.field.value);
    }
  }

  getDisplay(catalog: CatalogResource): any {
    return catalog.description;
  }
}
